import { makeVar } from '@apollo/client';
export const meStateVar = makeVar(null);
export const meStateHasChangesVar = makeVar(false);
export const pollIntensiveRequestVar = makeVar(false);
